import { render, staticRenderFns } from "./CalendarToday.vue?vue&type=template&id=5457ea04"
import script from "./CalendarToday.vue?vue&type=script&lang=js"
export * from "./CalendarToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports